<template lang="pug">
  .container
    form(
      class="form"
      @submit.prevent="submitForm"
    )
      .form__control-group
        label Title
        .container__input
          input(
            class="input__text"
            @change="updatePolicyTitle"
            type="text"
            v-model="title"
          )
          p.validation__error(:style="styles.validation(showTitleValidation)") Please enter a title
      .form__control-group
        label Rules
        p Create one or more groups of interaction rules to trigger the sequence
        div(
          :key="`rule-${index}`"
          v-for="(rule, index) in getActiveRules()"
        )
          p(
            class="text__or"
            v-if="index > 0 && getActiveRules().length > 1"
          ) or
          RuleGroup(
            :groupIndex="index"
          )
        button(
          class="button__action"
          type="button"
          @click="addNewRuleGroup"
        )
          i.glyphicon.glyphicon-plus.icon
          | Add Rule Group
        p.validation__error(:style="styles.validation(showRuleValidation && !getActiveRules())") Please create at least one rule group
      .form__control-group
        label Sequence
        .container__input
          section.cardWrap(
            class="cardWrap"
            v-if="getSelectedSequence"
            :style="styles.cardWrap"
            @click="toggleAddSequenceModal"
          )
            div(
              :style="styles.cardContainer"
            )
              p {{getSelectedSequence.name}}

          button(
            class="button__action"
            type="button"
            @click="toggleAddSequenceModal"
            v-if="!getSelectedSequence"
          )
            i.glyphicon.glyphicon-plus.icon
            | Add Sequence
          button(
            class="button__action"
            type="button"
            @click="toggleAddSequenceModal"
            v-if="getSelectedSequence"
          )
            i.glyphicon.glyphicon-edit.icon
            | Change Sequence
          p.validation__error(:style="styles.validation(showSequenceValidation)") Please select a sequence
      .form__control-group
        button.button__submit(
          type="submit"
        ) Save
</template>
<script>
import store from '../../store';
import vSelect from 'vue-select';
import Services from '../../services/Services';
import VueNotifications from 'vue-notifications';
import { postResource } from '../../services/Utils.js';
import RuleGroup from './RuleGroup';
export default {
  name: 'policyForm',
  components: {
    vSelect,
    RuleGroup
  },
  computed: {
    getSelectedSequence() {
      return store.getters.getSelectedSequence;
    },
    getActiveTitle() {
      return store.getters.getActivePolicy.title;
    }
  },
  methods: {
    getActiveRules() {
      return store.getters.getActivePolicy.rules;
    },
    getActivePolicy() {
      return store.getters.getActivePolicy;
    },
    parsePolicy() {
      let policy = { ...store.getters.getActivePolicy };
      // need to clean...
      let cleanedRules = policy.rules.map(r => {
        // r[n].interactionType
        const rule = {};
        rule.groupRules = r.groupRules.map(n => {
          // n.interationType
          const id = n.interactionType._id;
          const update = n;
          update.interactionType = id;
          update.operator = n.operator || '';
          update.property = n.property ? n.property._id : '';
          update.comparand = n.comparand || '';
          return update;
        });

        return rule;
      });

      policy.rules = cleanedRules;

      if (policy.sequence._id) {
        policy.sequence = policy.sequence._id;
      }

      return policy;
    },
    toggleTitleValidation() {
      if (this.showTitleValidation) {
        this.showTitleValidation = false;
      }
    },
    validateForm() {
      if (
        !this.getActivePolicy() ||
        !this.getActivePolicy().title.length ||
        this.getActivePolicy().rules.length ||
        !this.getActivePolicy().sequence.length
      ) {
        if (!this.getActivePolicy().title.length) {
          this.showTitleValidation = true;
        }
        if (!this.getActivePolicy().rules.length) {
          this.showRuleValidation = true;
        }

        if (!this.getActivePolicy().sequence) {
          this.showSequenceValidation = true;
        }

        return false;
      } else {
        this.showTitleValidation = false;
        this.showRuleValidation = false;
        this.showSequenceValidation = false;
        return true;
      }
    },
    submitForm() {
      let validForm = this.validateForm();

      if (
        !this.showTitleValidation &&
        !this.showRuleValidation &&
        !this.showSequenceValidation
      ) {
        let policy = this.parsePolicy();
        if (!this.id) {
          postResource('/v1/policies/create', false, policy)
            .then(res => {
              this.showSuccessMsg({ message: 'Policy created!' });
              return res;
            })
            .then(res => {
              setTimeout(() => {
                this.$router.push('/policies/');
              }, 600);
            })
            .catch(error => {
              this.showErrorMsg({
                message: 'An error occurred. Please try again.'
              });
            });
        } else {
          postResource('/v1/policies/update', false, policy)
            .then(res => {
              this.showSuccessMsg({ message: 'Policy updated!' });
            })
            .catch(error => {
              this.showErrorMsg({
                message: 'An error occurred. Please try again.'
              });
            });
        }
      }
    },
    updatePolicyTitle() {
      let activePolicy = store.getters.getActivePolicy;
      activePolicy.title = this.title;
      if (this.title.length) {
        this.showTitleValidation = false;
      }
      store.commit('setActivePolicy', activePolicy);
    },
    setActiveOption(val) {
      store.commit('setActivePolicyOption', val);
    },
    addNewRuleGroup() {
      let activePolicy = store.getters.getActivePolicy;
      if (!activePolicy.rules) {
        activePolicy.rules = [];
      }
      activePolicy.rules.push({
          ruleGroupId: '',
          groupRules: []
      });
      store.commit('setActivePolicy', activePolicy);
    },
    removeRuleGroup(index) {
      let activePolicy = store.getters.getActivePolicy;
      activePolicy.rules.splice(index, 1);
      store.commit('setActivePolicy', activePolicy);
    },
    toggleAddSequenceModal() {
      console.log('adding sequence to policy');
      this.showSequenceValidation = false;
      store.commit('showAddSequenceToPolicyModal', true);
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success,
      title: '',
      icon: '✅'
    },
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: '',
      icon: '❗️'
    }
  },
  data() {
    return {
      id: this.$route.params.shortId,
      title: '',
      saveText: 'Save',
      showTitleValidation: false,
      showSequenceValidation: false,
      showRuleValidation: false,
      styles: {
        cardWrap: {
          background: '#fff',
          display: 'flex',
          padding: '10px',
          flexFlow: 'row nowrap',
          justifyContent: 'space-between',
          width: 'calc(33.33% - 20px)',
          // margin: '10px',
          ':hover': {
            border: '1px solid #888',
            cursor: 'pointer'
          }
        },
        cardContainer: {
          display: 'flex',
          flexFlow: 'column nowrap'
        },
        validation: show => ({
          transition: 'all 0.2s',
          opacity: show ? '1' : '0'
        }),
        cardPreview: {
          background: 'teal',
          position: 'relative',
          padding: '20px'
        },
        cardName: {
          color: '#aaa',
          fontSize: '0.9em',
          marginBottom: '0'
        }
      }
    };
  },
  created() {
    if (!store.getters.getSequences.length) {
      Services.getSequences();
    }
    if (this.id) {
      this.title = this.getActiveTitle;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  margin: auto;
  width: 100%;
  max-width: 1280px;
  border-radius: 3px;
  margin-top: 2rem;
}

.validation__error {
  color: #e84545;
  margin-top: 8px;
}
.form {
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
}

.interaction__group {
  position: relative;
}

.form__control-group {
  margin-bottom: 2rem;
  // display: flex;
  // flex-direction: column;
  position: relative;

  &.sequences__control-group {
    flex-direction: column;
  }

  label {
    font-size: 1.1rem;
    margin-bottom: 5px;
    display: block;
  }

  input {
    // padding: 0.5rem;
    max-width: 600px;
    width: 100%;
  }

  p {
    font-size: 0.9rem;
    margin-bottom: 8px;
    margin-top: 0px;

    &.text__or {
      font-style: italic;
      font-weight: bold;
      margin-top: -15px;
    }
  }

  .cardWrap {
    background: #fff;
    display: flex;
    border: 1px solid #9c9898;
    padding: 10px;
    box-sizing: border-box;
    flex-flow: row nowrap;
    width: calc(33.33% - 20px);
    margin: 10px;
    margin-left: 0;
    transition: all 0.2s;
    &:hover {
      border: 1px solid #888;
      cursor: pointer;
    }
  }

  .button__action {
    margin-left: 0;
  }

  button:not(.button__submit):not(.button__action) {
    border-radius: 3px;
    border: 0;
    background: #cdcdcd;
    transition: all 0.2s;
    padding: 0.5rem;
    height: 40px;

    &.button__new-group {
      display: block;
      width: auto;
    }

    &.button__remove {
      position: absolute;
      right: 9px;
      top: -0.5rem;
      font-size: 0.9rem;
      padding: 0.25rem 0.5rem;
      height: 25px;
    }

    &:hover {
      background: darken(#cdcdcd, 5%);
      cursor: pointer;
    }

    // &.button__submit {
    //   background: #6ab04c;
    //   color: #fff;
    //   width: 25%;

    //   &:hover {
    //     background: darken(#6ab04c, 5%);
    //   }
    // }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/general/PolicyForm.vue